import { FC } from 'react';
import { PrimaryMenuMobile } from '../../components/PrimaryMenu/PrimaryMenuMobile';
import { useCustomerIdContext, useUserData } from '../../context';
import { BottomPrimaryMenuItemsMobile } from '../BottomPrimaryMenuItems/BottomPrimaryMenuItemsMobile';
import { TopPrimaryMenuItemsMobile } from '../TopPrimaryMenuItems/TopPrimaryMenuItemsMobile';
import { DefaultPrimaryMenuProps } from './DefaultPrimaryMenu';

export const DefaultPrimaryMenuMobile: FC<DefaultPrimaryMenuProps> = ({ topItems, bottomItems }) => {
  const { currentCustomer } = useCustomerIdContext();
  const { userData } = useUserData();
  const isDisabled = !(currentCustomer?.externalId && userData);

  return (
    <PrimaryMenuMobile
      isDisabled={isDisabled}
      topItems={topItems || <TopPrimaryMenuItemsMobile />}
      bottomItems={bottomItems || <BottomPrimaryMenuItemsMobile />}
    />
  );
};
